import SearchOffIcon from '@mui/icons-material/SearchOff'
import { Stack, Typography } from '@mui/material'

export interface NoSearchResultsProps {
  query: string
}

export const NoSearchResults = ({ query }: NoSearchResultsProps) => {
  return (
    <Stack
      data-testid="no-search-results"
      sx={{
        fontSize: 48,
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        paddingY: 6,
        color: 'text.secondary',
      }}
    >
      <SearchOffIcon fontSize="inherit" />
      <Typography
        variant="h3"
        sx={{
          color: 'text.secondary',
        }}
      >
        No templates with term "{query}"
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        Try searching with a different term
      </Typography>
    </Stack>
  )
}
